import { useLanguage } from '../../../context/LanguageContext';

export default function Services() {
  const { t } = useLanguage();

  const services = [
    {
      icon: 'ri-hand-heart-line',
      title: t('services.card1Title'),
      description: t('services.card1Description'),
    },
    {
      icon: 'ri-global-line',
      title: t('services.card2Title'),
      description: t('services.card2Description'),
    },
    {
      icon: 'ri-links-line',
      title: t('services.card3Title'),
      description: t('services.card3Description'),
    },
    {
      icon: 'ri-building-2-line',
      title: t('services.card4Title'),
      description: t('services.card4Description'),
    },
  ];

  return (
    <section id="services" className="py-32 bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="text-[#1A2B4A] text-2xl mb-4">◆</div>
          <h2 className="text-5xl font-serif font-bold text-[#1A2B4A] mb-6">{t('services.heading')}</h2>
          <p className="text-lg text-gray-600">{t('services.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 text-center"
            >
              <div className="w-18 h-18 rounded-full bg-[#C9A961] flex items-center justify-center mx-auto mb-8">
                <i className={`${service.icon} text-4xl text-[#1A2B4A]`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2B4A] mb-5">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-8 max-w-xs mx-auto">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
